import { IdType } from "./BaseTypes"; // string of length 24

export const CHAT_STATUS = {
  ACTIVE: "active",
  REPORTED: "reported",
  BLOCKED: "blocked",
  DELETED: "deleted",
} as const;
export type ChatStatusType = (typeof CHAT_STATUS)[keyof typeof CHAT_STATUS];
export type UserElemType = {
  userId: IdType;
  state: ChatStatusType;
  unreadMessages: number; // should be non-negative
};

export type ChatType = {
  _id: IdType;
  users: UserElemType[]; // non-empty array
  productId: IdType;
};

export type ChatPostType = {
  users: UserElemType[];
  productId: IdType;
};
